import { faSort, faSortDown, faSortUp } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useMemo } from 'react';

export interface SortValue<T>{
  type: T;
  fallback?: T;
  asc: boolean;
}
type BaseProps<T> = {
  type: T;
  fallback?: T;
  onChange: (value: SortValue<T>) => void;
  value?: SortValue<T>;
  invert?: boolean;
  children?: React.ReactNode;
};
type Props<T> = Omit<React.ThHTMLAttributes<HTMLTableCellElement>,
 keyof BaseProps<T>> & BaseProps<T>;

const SortableHeader = <T, >({
  type,
  value,
  fallback,
  onChange,
  invert,
  children,
  ...props
}: Props<T>) => {
  const selected = useMemo(() => value && value.type === type, [value, type]);
  const icon = useMemo(() => {
    if (selected && value) {
      if (value.asc === !(invert || false)) {
        return faSortDown;
      }
      return faSortUp;
    }
    return faSort;
  }, [value, selected, invert]);

  const buttonClass = useMemo(() => (selected ? 'sort-link active' : 'sort-link'), [selected]);
  return (
    <th {...props}>
      <button
        type="button"
        title="Sorter"
        className={buttonClass}
        onClick={() => {
          if (value) {
            const flip = type === value.type ? !value.asc : !invert;
            onChange({ type, asc: flip, fallback });
          }
        }}
      >
        {children}
        <FontAwesomeIcon
          icon={icon}
        />
      </button>
    </th>
  );
};
export default SortableHeader;
